import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchCompanyDuplicateModal = createAsyncThunk(
  "companyDuplicateModal/fetchCompanyDuplicateModal",
  async (country) => {
    return fetch(
      `${baseUrl}/api/company-is-duplicated/${country.countryCode}/`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Accept-Language":
            country.language === "en" ? "en-UK" : country.language,
        },
      }
    ).then((res) => errorStatusProvider(res));
  }
);

export const getCompanyDuplicateModal =
  (countryCode, language) => async (dispatch) => {
    const result = await dispatch(
      fetchCompanyDuplicateModal({ countryCode, language })
    );
    const { data, responseStatus } = result.payload;
    dispatch(setShowServerErrorMessage(responseStatus));
    return data;
  };

export const companyDuplicateModalSlice = createSlice({
  name: "companyDuplicateModal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyDuplicateModal.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCompanyDuplicateModal.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload.data.page_content;
      })
      .addCase(fetchCompanyDuplicateModal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default companyDuplicateModalSlice.reducer;
